import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Assuming react-router-dom is used for navigation
// Assuming BACKEND_URL is defined in Constants.js
import { BACKEND_URL } from '../../Constants';

const BACKEND = `${BACKEND_URL}/api/chatbotai-quizzes`;

const ChatbotAIQuizzesList = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        setLoading(true); // Set loading to true before fetching
        const response = await fetch(BACKEND);
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! Status: ${response.status}, Body: ${errorText}`);
        }
        const data = await response.json();
        setQuizzes(data);
      } catch (err) {
        console.error('Failed to fetch quizzes:', err);
        setError(err.message || 'An unexpected error occurred.');
      } finally {
        setLoading(false); // Set loading to false after fetching (success or failure)
      }
    };

    fetchQuizzes();
  }, []); // Empty dependency array means this effect runs once on mount

  // Function to handle deleting a quiz
  const handleDeleteQuiz = async (quizId) => {
    // Using native confirm for simplicity as per original context, but generally a custom modal is preferred in Canvas
    if (window.confirm('Are you sure you want to delete this quiz and all its questions? This action cannot be undone.')) {
      try {
        const response = await fetch(`${BACKEND}/${quizId}`, {
          method: 'DELETE',
        });
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Failed to delete quiz: Status ${response.status}, Body: ${errorText}`);
        }
        // If deletion is successful, update the state to remove the quiz from the list
        setQuizzes((prevQuizzes) => prevQuizzes.filter((quiz) => quiz._id !== quizId));
        console.log(`Quiz with ID ${quizId} deleted successfully.`);
      } catch (err) {
        console.error('Error deleting quiz:', err);
        setError(err.message || 'Failed to delete quiz.');
      }
    }
  };

  if (loading) {
    return (
      <div className="container py-4">
        <p className="text-center">Loading quizzes...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-4">
        <p className="text-danger text-center">Error: {error}</p>
      </div>
    );
  }

  return (
    <>
        <h2 className="text-center mb-4">All Chatbot AI Quizzes</h2> {/* Using h2 and text-center from BangoDash */}

        <div className="d-flex justify-content-end mb-4"> {/* Using Bootstrap-like classes for flex and margin */}
          <Link
            to="/dashboard/chatbotai-quizzes/add" // Link to create a new quiz
            className="btn btn-primary" // Using BangoDash btn-primary class
          >
            + Create New Quiz
          </Link>
        </div>

        {quizzes.length === 0 ? (
          <p className="text-center text-muted">No quizzes found. Click "Create New Quiz" to add one!</p>
        ) : (
          <div className="card"> {/* Using BangoDash card class */}
            <div className="card-body"> {/* Using BangoDash card-body class */}
              <ul className="list-group list-group-flush"> {/* Using BangoDash list-group and list-group-flush */}
                {quizzes.map((quiz) => (
                  <li key={quiz._id} className="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="card-title">{quiz.title}</h5> {/* Using BangoDash card-title */}
                      <p className="text-muted">{quiz.description}</p> {/* Using BangoDash text-muted */}
                      <p className="text-muted small">
                        Status: <span className={quiz.status === 'Published' ? 'text-success' : 'text-warning'}>
                          {quiz.status}
                        </span>
                      </p>
                      <p className="text-muted small">Questions: {quiz.questions ? quiz.questions.length : 0}</p>
                    </div>
                    <div className="btn-group" role="group"> {/* Using BangoDash btn-group */}
                      <Link
                        to={`/dashboard/chatbotai-quizzes/quiz/${quiz._id}`} // Link to edit specific quiz
                        className="btn btn-success btn-sm" // Using BangoDash btn-success and btn-sm
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() => handleDeleteQuiz(quiz._id)}
                        className="btn btn-danger btn-sm" // Using BangoDash btn-danger and btn-sm
                      >
                        Delete
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
     </>
  );
};

export default ChatbotAIQuizzesList;
